import Utils from '@/services/utils.js';
import StringTruncated from "@/components/ui/table-renderer/StringTruncated";
import ActiveRenderer from "./table-renderer/ActiveRenderer"
import {useDvFlagAccess} from "../../../services/featureFlag";

export const planningListColumns = (window) => ([
    {
        key: 'label',
        label: window.V.$i18n.t('planning.columns.name'),
        showPopup: false,
        activeFilter: '',
        activeSort: '+',
        sortable: true,
        filter: {
            type: 'text'
        },
        linkTo: useDvFlagAccess("beepiz-profile-can:update") ? '/parameters/planning/:id' : null
    },
    {
        key: 'timeslotSumary',
        label: window.V.$i18n.t('planning.columns.reminders'),
        renderer: StringTruncated,
    },
    {
        key: 'groupsCount',
        label: window.V.$i18n.t('planning.columns.groups'),
        width: '100px',
    },
    {
        key: 'profilesCount',
        label: window.V.$i18n.t('planning.columns.profiles'),
        width: '100px',
    },
    {
        key: 'datisCount',
        label: window.V.$i18n.t('planning.columns.loneworkers'),
        width: '150px',
    },
    {
        key: 'active',
        label: window.V.$i18n.t('planning.columns.state'),
        width: '100px',
        renderer: ActiveRenderer,
        activeFilter: '',
        activeSort: false,
        sortable: true,
        showPopup: false,
        filter: {
            type: 'list',
            values: [
                {
                    id: 0,
                    label: window.V.$i18n.t('planning.state_labels.activated')
                },
                {
                    id: 1,
                    label: window.V.$i18n.t('planning.state_labels.deactivated')
                }
            ]
        },
    }
]);